import router from '@/router'
import { login, doRefreshToken, getInfo } from '@/service/api/systemApi'
import axiosInstance from '@/plugins/axios'

const initUserState = {
  // 认证信息
  auth: {
    accessToken: '',
    refreshToken: '',
  },
  // 用户数据
  userName: '',
  userId: '',
  avatar: '',
}
const user = {
  state: initUserState,
  mutations: {
    SET_TOKEN: (state, { accessToken, refreshToken }) => {
      state.auth.accessToken = accessToken
      state.auth.refreshToken = refreshToken
    },
    SET_USER(state, user) {
      for (const i in user) {
        if (i in state) {
          state[i] = user[i]
        }
      }
    },
    RESET_USER(state) {
      for (const i in initUserState) {
        state[i] = initUserState[i]
      }
      for (const j in state) {
        if (!(j in initUserState)) {
          delete state[j]
        }
      }
    },
  },

  actions: {
    // 登录
    Login({ commit }, loginParams) {
      return new Promise(async (resolve, reject) => {
        try {
          const { userName, userId, token } = await login(loginParams)
          commit('SET_USER', { userName, userId })
          commit('SET_TOKEN', { accessToken: token })
          resolve()
        } catch (e) {
          reject(e)
        }
      })
    },
    RefreshToken({ commit, state }) {
      return new Promise(async (resolve, reject) => {
        try {
          const { accessToken, refreshToken } = await doRefreshToken({
            refreshToken: state.auth.refreshToken,
          })
          commit('SET_TOKEN', { accessToken, refreshToken })
          resolve()
        } catch (e) {
          reject(e)
        }
      })
    },
    GetInfo({ commit, state, dispatch }) {
      return new Promise(async (resolve, reject) => {
        // 获取用户信息（权限信息单独到权限模块，有其他信息在此设置）
        try {
          const auth = await getInfo()
          const res = await axiosInstance.get('/user/admin/auth/current')

          commit('SET_USER', { avatar: res.data.logoUrl })
          // dispatch('UpdateMessageCount')
          resolve(auth)
        } catch (e) {
          reject(e)
        }
      })
    },

    // 登出
    Logout({ commit }, { type = 'default' } = {}) {
      return new Promise((resolve, reject) => {
        // 清理permissions  -> 清理用户数据 -> 清理动态routes(好像没有对应的api，只能通过window重载？)
        commit('RESET_PERMISSION')
        commit('RESET_USER')

        const loginPage = `/user/login`

        // 通过router登出
        if (type === 'default') {
          if (loginPage === router.currentRoute.path) {
            reject(new Error('Dispatch [Logout] in loginPage'))
            return
          }
          const to = `${loginPage}?redirect=${window.location.pathname + window.location.search}`
          router.push(to)
          resolve()
        }
        // window重载
        if (type === 'reLaunch') {
          // 这里直接跳转登录，不要通过根路径redirect到登录，因为根路径是动态绑定的menu
          window.location.href = loginPage
          resolve()
        }
        // 其他操作
        if (type === 'noJump') {
          resolve()
        }
      })
    },
  },
}

export default user
